import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@material-ui/core";
import { ajustesApi } from "src/services/ajustesApi";
import { useSnackbar } from "src/components/snackbar";

export default function EditarComisionesPredefinida(props) {
  const { open, setOpen, comision } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [comisionEntrada, setComisionEntrada] = useState(comision.comision);

  const [actualizarComisionPredefinida] =
    ajustesApi.useUpdateComisionesPredefinidasMutation();

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeComision = (e) => {
    if (e.target.value >= 0 && e.target.value <= 100) {
      setComisionEntrada(e.target.value);
    } else {
      setComisionEntrada(0);
    }
  };

  const guardarDatos = () => {
    if (
      comisionEntrada === "" ||
      comisionEntrada === "" ||
      Number.isNaN(comisionEntrada)
    ) {
      enqueueSnackbar("La comisión debe ser un número.", {
        variant: "error",
      });
    } else {
      actualizarComisionPredefinida({
        id: comision.id,
        body: {
          comision: comisionEntrada,
        },
      })
        .unwrap()
        .then(() => {
          enqueueSnackbar("Comisión actualizada correctamente.", {
            variant: "success",
          });
          handleClose();
        })
        .catch(() => {
          enqueueSnackbar(
            "Ocurrió un error en el servidor. Inténtelo nuevamente más tarde.",
            { variant: "error" },
          );
        });
    }
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      id="dialogEditarComisionPredefinidas"
    >
      <DialogTitle>Editar Comisión Tareas Normales</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          style={{ marginTop: "10px" }}
          type="number"
          label="Porcentaje Comisión"
          value={comisionEntrada}
          onChange={handleChangeComision}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cerrar</Button>
        <Button onClick={guardarDatos} variant="contained">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
